import { colors } from '@atlaskit/theme';
import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { borderColor, SPACE_COMFORTABLE } from '@/styles';

export const SEARCH_MIN_HEIGHT = '40px';

export const root = css`
  display: grid;
  grid-gap: 6px;
  grid-auto-rows: auto;

  margin-top: ${SPACE_COMFORTABLE}px;
`;

export const main = css`
  display: flex;
  flex-flow: row nowrap;

  position: relative;
  justify-content: space-between;

  min-height: ${SEARCH_MIN_HEIGHT};
  padding: 2px;

  border: 2px solid ${borderColor};
  border-radius: 6px;
  background-color: ${token('elevation.surface.sunken', colors.N10)};

  will-change: border-color;
`;

export const inputArea = css`
  display: flex;
  flex-flow: row wrap;
`;

export const filtersArea = css`
  padding: 6px;
  margin-left: 6px;
  border-left: 2px dotted ${borderColor};

  /* NOTE: Slight manual adjustment to true visual vertical alignment */
  position: relative;
  top: 2px;
`;

export const setIsInputFocusedStyle = (isInputFocused: boolean) => css`
  ${isInputFocused && ` border-color: ${token('color.border.focused', colors.B100)};`}
`;
